import React, { useEffect, useRef, useState } from "react";
import { Tabs, Tab, Box, Button, Modal, CircularProgress } from "@mui/material";
import axios from "axios";
import DataTable from "../DataTable/DataTable";
import Loading from "../Loading";
import UploadModal from "../UploadModal/UploadModal";
import Discrepancy from "../Discrepancy/Discrepancy";
import SofDetail from "../Discrepancy/SofDetail";
import { FaEye } from "react-icons/fa";
import { BiMessageSquareDetail } from "react-icons/bi";
import { MdDifference } from "react-icons/md";
import { CgSandClock } from "react-icons/cg";
import AmendmentDetail from "../Discrepancy/AmendmentDetail";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import { Tooltip } from "@mui/material";
import MoreDetailsModal from "../Discrepancy/MoreDetailsModal";
import CreditNoteDetail from "../Discrepancy/CreditNoteDetail";
import { useVendor } from "../../utils/Context";
import { getPermissionByPrefix } from "../../utils/permissions";
import { useErrorToast } from "../../hooks/useErrorToast";
import YearMonthFilter from "./YearMonthFilter";
import CreditNoteDetailsModal from "./CreditNoteDetailsModal";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { PiFileCsv } from "react-icons/pi";
import { FiUpload } from "react-icons/fi";
import InvoiceSummaryTable from "./InvoiceSummaryTable";
import DateRangeFilter from "./DateRangeFilter";
import InvoiceSummaryTableB from "./InvoiceSummaryTableB";

function Document() {
  const showError = useErrorToast();
  const [columns, setColumns] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [invoice, setInvoice] = useState([]);
  const [sof, setSof] = useState([]);
  const [amendment, setAmendment] = useState([]);
  const [creditNote, setCreditNote] = useState([]);
  const [other, setOther] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const fileInputRef = React.createRef();
  const [date, setDate] = useState("");
  const [docId, setDocId] = useState("");
  const [discrepancyModal, setDiscrepancyModal] = useState(false);
  const [discrepancyData, setDiscrepancyData] = useState([]);
  const [discrepancyCircuitTotals, setDiscrepancyCircuitTotals] = useState([]);
  const [discrepancyGroupedServices, setDiscrepancyGroupedServices] = useState([]);
  const [sofData, setSofData] = useState([]);
  const [creditNoteData, setCreditNoteData] = useState([]);
  const [detailModal, setDetailModal] = useState(false);
  const [amendmentModal, setAmendmentModal] = useState(false);
  const [creditNoteModal, setCreditNoteModal] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [selectedColumn, setSelectedColumn] = useState({});
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(true);
  const { search } = useLocation();
  const [searchParam, setSearchParam] = useSearchParams();
  const [currentParam, setCurrentParam] = useState("")
  const navigate = useNavigate();
  const [moreModalOpen, setMoreModalOpen] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(-1);
  const { selectedVendor: selectVendorInContext } = useVendor();


  const fetchInvoiceDetails = async (docId) => {
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/get-invoice-details-by-doc/${docId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      setInvoiceDetails(response.data.data);
      setMoreModalOpen(true);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.allSettled([
      fetchInvoice(),
      fetchSof(),
      fetchAmendment(),
      fetchOther(),
      fetchCreditNote(),
      handleVendor(),
    ]).then(() => {
      setLoading(false);
    });
  }, [selectVendorInContext]);

  useEffect(() => {
    const tab = searchParam.get("tab");
    if (tab === "invoice") {
      setValue(2);
      setColumns(invoiceColumns(getDiscrepancyrow, getFile, processFile, fetchCreditfromInvoice));
    } else if (tab === "sof") {
      setValue(1);
      setColumns(
        sofColumns(getDetail, getFile, processFile, fetchInvoiceDetails)
      );
    } else {
      setColumns(ammendentColumns(getDetail, getFile, processFile));
    }
  }, [search]);

  const [value, setValue] = useState(0);

  const handleVendor = async () => {
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(`${process.env.REACT_APP_URL}/vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      setVendor(response.data);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.error ||
        //     "Something went wrong. Please try again."
        // );
      }
    }
  };

  const handleChange = (event, newValue) => {
    searchParam.delete("tab");
    if (newValue === 0) {
      setColumns(ammendentColumns(getDetail, getFile, processFile));
    } else if (newValue === 1) {
      setColumns(
        sofColumns(getDetail, getFile, processFile, fetchInvoiceDetails)
      );
    } else if (newValue === 2) {
      let ifExisitng = searchParam.get("search_for") === "discrepancy";
      if (ifExisitng) {
        setSearchParam({});
        fetchInvoice(false);
      }
      setColumns(invoiceColumns(getDiscrepancyrow, getFile, processFile, fetchCreditfromInvoice));
    } else if (newValue === 3) {
      setColumns(
        creditColumns(getDetail, getFile, processFile, fetchInvoiceDetails)
      );
    } else {
      setColumns(otherColumns(getFile));
    }
    setValue(newValue);
  };
const [yearParam, setYearParam] = useState(null);
const [monthParam, setMonthParam] = useState(null);

  // const fetchInvoice = async (status = true) => {
    const fetchInvoice = async (status = true, yr = yearParam, mn = monthParam, start_date = null, end_date = null) => {
      setLoading(true)
    try {
      const token = localStorage.getItem("tokenInv");
      const searchFor = searchParam.get("search_for");
const year = yr || searchParam.get("year");
    const month = mn || searchParam.get("month");
    const currency = searchParam.get("currency");
      setCurrentParam(searchFor);
      setYearParam(year);
      setMonthParam(month);
      let url = `${process.env.REACT_APP_URL}/get-all-invoices?search_for=${
        status ? searchFor || "" : ""
      }`;
      if (selectVendorInContext !== -1) {
        url += `&vendor_id=${selectVendorInContext}`;
      }
      const search_start = start_date || searchParam.get("start_date");
      const search_end = end_date || searchParam.get("end_date");
      if (search_start && search_end) {
      url += `&start_date=${search_start}&end_date=${search_end}`;
    } else {
      if (year) url += `&year=${year}`;
      if (month && month !== "all") url += `&month=${month}`;
    }
      if (currency && currency !== "all") {
        url += `&currency=${currency}`;
      }
      let response = await axios.get(
        url,
        // `${process.env.REACT_APP_URL}/get-all-invoices?search_for=`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      let data = response.data.data.map((el) => ({
        ...el,
        status: el?.status === "processed" ? "Processed" : "Pending",
        discrepancy_detected: el.discrepancy_detected ? "True" : "False",
        // taxes_and_surcharges: el?.taxes_and_surcharges
        //   ? el?.taxes_and_surcharges?.toFixed(2)
        //   : "",
        // total_amount: el?.total_amount
        //   ? parseInt(el?.total_amount).toFixed(2)
        //   : "",
        // total_usd: el?.total_usd ? el?.total_usd?.toFixed(2) : "",
        // taxes_and_surcharges: el?.taxes_and_surcharges
        //   ? Number(el.taxes_and_surcharges).toLocaleString(undefined, {
        //       minimumFractionDigits: 2,
        //       maximumFractionDigits: 2,
        //     })
        //   : "",
        taxes_and_surcharges: el?.taxes_and_surcharges != null
  ? Number(el.taxes_and_surcharges).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    })
  : "",
        taxes_usd: el?.taxes_usd != null
  ? Number(el.taxes_usd).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    })
  : "",
        discount_usd: el?.discount_usd != null
  ? Number(el.discount_usd).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    })
  : "",
  total_amount: el?.total_amount != null
  ? Number(el.total_amount).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  : "",
total_usd: el?.total_usd != null
  ? Number(el.total_usd).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  : "",
sum_amount: el?.sum_amount != null
  ? Number(el.sum_amount).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  : "",
sum_amount_usd: el?.sum_amount_usd != null
  ? Number(el.sum_amount_usd).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  : "",
        // total_amount: el?.total_amount
        //   ? Number(el.total_amount).toLocaleString(undefined, {
        //       minimumFractionDigits: 2,
        //       maximumFractionDigits: 2,
        //     })
        //   : "",
        // total_usd: el?.total_usd
        //   ? Number(el.total_usd).toLocaleString(undefined, {
        //       minimumFractionDigits: 2,
        //       maximumFractionDigits: 2,
        //     })
        //   : "",
        // invoice_date: el?.invoice_date ? el?.invoice_date : "",
        invoice_date: el?.invoice_date ? new Date(el?.invoice_date) : "",
        final_discrepancy:
          parseInt(el.total_discrepancy) - parseInt(el.total_adj),
          missing_services_status:
    el?.has_missing_services === 1 ? "Incomplete" : "Complete",
      }));
      // console.log("data",data)
      setInvoice(data);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    } finally{
      setLoading(false)
    }
  };

  const fetchSof = async () => {
    try {
      const token = localStorage.getItem("tokenInv");
      let url = `${process.env.REACT_APP_URL}/get-all-sof?doc_type=sof`;
      if (selectVendorInContext !== -1) {
        url += `&vendor_id=${selectVendorInContext}`;
      }
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      let data = response.data.data.map((el) => ({
        ...el,
        status: el.status === "processed" ? "Processed" : "Pending",
        // date: el.date ? el.date : "",
        date: el.date ? new Date(el.date) : "",
      }));
      setSof(data);
    } catch (error) {
      if (error.response.status === 401) {
        // showError("Session Expired! Please Login");
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    }
  };

  const fetchAmendment = async () => {
    try {
      const token = localStorage.getItem("tokenInv");
      let url = `${process.env.REACT_APP_URL}/get-all-sof?doc_type=amendment`;
      if (selectVendorInContext !== -1) {
        url += `&vendor_id=${selectVendorInContext}`;
      }
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      let data = response.data.data.map((el) => ({
        ...el,
        status: el.status === "processed" ? "Processed" : "Pending",
        // date: el.date ? el.date : "",
        date: el.date ? new Date(el.date) : "",
      }));
      setAmendment(data);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    }
  };

  const fetchCreditNote = async () => {
    try {
      const token = localStorage.getItem("tokenInv");
      let url = `${process.env.REACT_APP_URL}/get-all-sof?doc_type=credit-note`;
      if (selectVendorInContext !== -1) {
        url += `&vendor_id=${selectVendorInContext}`;
      }
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      let data = response.data.data.map((el) => ({
        ...el,
        status: el.status === "processed" ? "Processed" : "Pending",
        // date: el?.date ? el?.date : "",
        date: el.date ? new Date(el.date) : "",
      }));
      setCreditNote(data);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    }
  };
  const fetchOther = async () => {
    try {
      const token = localStorage.getItem("tokenInv");
      let url = `${process.env.REACT_APP_URL}/get-all-sof?doc_type=other`;
       if (selectVendorInContext !== -1) {
        url += `&vendor_id=${selectVendorInContext}`;
      }
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      let data = response.data.data.map((el, index) => ({
        ...el,
        status: el.status === "processed" ? "Processed" : "Pending",
      }));
      setOther(data);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    }
  };

  const getDiscrepancyrow = async (params) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/get-discrepancy/${params.invoice_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      
      let rawData = response.data.data;
      let items = [];
      let circuitTotals = [];
      let groupedServices = [];

      // Case 1: Standard Wrapper where response.data.data is the array, and circuit_totals might be sibling
      if (Array.isArray(rawData)) {
        items = rawData;
        // Check if circuit_totals is a sibling in response.data
        if (response.data.circuit_totals && Array.isArray(response.data.circuit_totals)) {
            circuitTotals = response.data.circuit_totals;
        }
        if (response.data.grouped_services && Array.isArray(response.data.grouped_services)) {
          groupedServices = response.data.grouped_services;
        }
      } 
      // Case 2: Nested Object in response.data.data
      else if (rawData && typeof rawData === 'object') {
        items = rawData.data || [];
        circuitTotals = rawData.circuit_totals || [];
        groupedServices = rawData.grouped_services || [];
      }
      
      // console.log("Extracted items:", items);
      // console.log("Extracted circuitTotals:", circuitTotals);
      // console.log("Extracted groupedServices:", groupedServices);

      let data = items.map((el, index) => {
        return {
          ...el,
          id: index,
          service_name_y: el.service_name_y || el.service_name_x,
          // amount: el.amount ? parseFloat(el.amount).toFixed(2) : 0,
          location_id_y: el?.location_id_y || el?.location_id_x,
        };
      });

      // Process circuit totals if needed (e.g. add ids for DataGrid)
      const processedCircuitTotals = circuitTotals.map((el, index) => ({
        ...el,
        id: index, 
      }));

      const processedGroupedServices = groupedServices.map((el, index) => ({
        ...el,
        id: index,
      }));

      setDiscrepancyData(data);
      setDiscrepancyCircuitTotals(processedCircuitTotals);
      setDiscrepancyGroupedServices(processedGroupedServices);
      setInvoiceNo(params.invoice_id);
      setDiscrepancyModal(true);
      setSelectedColumn(params);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const processFile = async (value, params) => {
    setLoading(true);
    let response = null; 
    try {
      if (value === 0) {
        const formData = new FormData();
        const token = localStorage.getItem("tokenInv");
        formData.append("id", params.id);
         response = await axios.post(
          `${process.env.REACT_APP_URL}/process_invoice`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await fetchInvoice();
      } else if (value === 1) {
        const formData = new FormData();
        formData.append("doc_id", params.id);
        const token = localStorage.getItem("tokenInv");
         response = await axios.post(
          `${process.env.REACT_APP_URL}/process-sof`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await fetchSof();
      } else if (value === 4) {
        const formData = new FormData();
        formData.append("doc_id", params.id);
        const token = localStorage.getItem("tokenInv");
         response = await axios.post(
          `${process.env.REACT_APP_URL}/process-credit-note`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await fetchCreditNote();
      } else {
        const formData = new FormData();
        formData.append("doc_id", params.id);
        const token = localStorage.getItem("tokenInv");
         response = await axios.post(
          `${process.env.REACT_APP_URL}/process-amendment`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await fetchAmendment();
      }
      toast.success(response?.data?.msg || "Processed successfully.")
    } catch (error) {
      if (error?.response?.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error?.response?.data?.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    } finally {
      setLoading(false);
    }
  };

  const getDetail = async (params, value) => {
    // console.log(value);
    setLoading(true);
    try {
      if (value === 1) {
        const token = localStorage.getItem("tokenInv");
        // let response = await axios.get(
        //   `${process.env.REACT_APP_URL}/get-sof-by-id/${params.doc_id}?ref_id=${params?.ref_id}`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`,
        //       "Content-Type": "application/json",
        //       "ngrok-skip-browser-warning": "true",
        //     },
        //   }
        // );
        let url = `${process.env.REACT_APP_URL}/get-sof-by-id/${params.doc_id}`;
          if (params?.ref_id) {
            url += `?ref_id=${params.ref_id}`;
          }

          const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "ngrok-skip-browser-warning": "true",
            },
          });
        const resData = response.data.data;
        let sofItems = [];
        let parties = [];
        let signatures = [];

        if (Array.isArray(resData)) {
          sofItems = resData;
        } else if (resData && typeof resData === 'object') {
          sofItems = resData.sof_items || [];
          parties = resData.parties || [];
          signatures = resData.signatures || [];
        }

        let formattedItems = sofItems.map((el, index) => {
          return {
            ...el,
            id: index,
            // ref_id: el?.ref_id,
            mrc: `${el.currency} ${el.mrc}`,
            nrc: `${el.currency} ${el.nrc}`,
            converted_mrc_usd: el.converted_mrc_usd
              ? parseFloat(el.converted_mrc_usd).toFixed(2)
              : 0.0,
            converted_nrc_usd: el.converted_nrc_usd
              ? parseFloat(el.converted_nrc_usd).toFixed(2)
              : 0.0,
            conversion_rate: el.conversion_rate || 0.0,
          };
        });
        setSofData({ items: formattedItems, parties, signatures });
        setInvoiceNo(params.doc_id);
        setDetailModal(true);
      } else if (value === 2) {
        const token = localStorage.getItem("tokenInv");
        let response = await axios.get(
          `${process.env.REACT_APP_URL}/get-amendment/${params.doc_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "ngrok-skip-browser-warning": "true",
            },
          }
        );
        let data = response.data.data.map((el, index) => {
          return {
            ...el,
            id: index,
          };
        });
        setSofData(data);
        setInvoiceNo(params.doc_id);
        setAmendmentModal(true);
      } else if (value === 4) {
        const token = localStorage.getItem("tokenInv");
        let response = await axios.get(
          `${process.env.REACT_APP_URL}/get-credit-note-by-id/${params.doc_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "ngrok-skip-browser-warning": "true",
            },
          }
        );
        let data = response.data.data.map((el, index) => {
          return {
            ...el,
            id: index,
            total_usd: `${el.currency} ${el.total_usd}`,
          };
        });
        setCreditNoteData(data);
        setInvoiceNo(params.doc_id);
        setCreditNoteModal(true);
      }
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    } finally {
      setLoading(false);
    }
  };

  // const getFile = (params) => {
  //   window.open(`${process.env.REACT_APP_URL}${params.enc_name}`, "_target");
  // };

  // const getFile = (params) => {
  //   const fileUrl = params.uploaded_on_s3 === 1
  //     ? params.enc_name
  //     : `${process.env.REACT_APP_URL}${params.enc_name}`;
  //   if (params.uploaded_on_s3 === 1) {
  //     const a = document.createElement('a');
  //     a.href = fileUrl;
  //     a.download = params.name;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //   } else {
  //     window.open(fileUrl, "_target");
  //   }
  // };

  const getFile = (params) => {
    const fileUrl =
      params.uploaded_on_s3 === 1
        ? params.enc_name
        : `${process.env.REACT_APP_URL}${params.enc_name}`;
    setPdfUrl(fileUrl);
    setLoadingPdf(false);
    setPdfViewerOpen(true);
  };

  const handlePdfViewerClose = () => {
    setPdfViewerOpen(false);
    setLoadingPdf(true);
  };

  const handlePdfLoad = () => {
    setLoadingPdf(false);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = pdfUrl.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
    } else {
      alert("Please upload a PDF file");
      setFile(null);
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Please select a PDF file");
      return;
    }

    if (selectVendorInContext === -1) {
      alert("Please select a Vendor");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("contract_file", file);
    formData.append(
      "type",
      value === 0
        ? "amendment"
        : value === 1
        ? "sof"
        : value === 2
        ? "invoice"
        : value === 3
        ? "credit-note"
        : "other"
    );
    formData.append("vendor_id", selectVendorInContext);
    if (date) {
      formData.append("date", date);
    }
    if (docId) {
      formData.append("doc_id", docId);
    }

    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/upload-sof`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("File uploaded successfully!", response);
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setModalIsOpen(false);
      if (value === 0) {
        await fetchAmendment();
      } else if (value === 1) {
        await fetchSof();
      } else if (value === 2) {
        await fetchInvoice();
      } else if (value === 3) {
        await fetchCreditNote();
      } else {
        await fetchOther();
      }
      setDate("");
      setDocId("");
      toast.success(response?.data?.msg || "Uploaded successfully.")
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error.response?.data?.msg || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.msg || "Something went wrong. Please try again."
        // );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if (value === 2) {  
    fetchInvoice();
  }
}, [searchParam, value, yearParam, monthParam]); 

const invoiceFiltersActive = searchParam.get('search_for') || searchParam.get('year') || searchParam.get('month') || yearParam || monthParam || searchParam.get('start_date') || searchParam.get('end_date');
const [loadingRowId, setLoadingRowId] = useState(null);
  const [openCreditModal, setOpenCreditModal] = useState(false);
  const [creditNoteDataInvoice, setCreditNoteDataInvoice] = useState([]);


    const fetchCreditfromInvoice = async (invoice_id) => {
    // setLoadingDisRowId(rowId)
    // setLoading(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/credit-notes/invoice/${invoice_id}`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCreditNoteData(response.data.data || []);
      setOpenCreditModal(true);
      toast.success(response?.data?.message || "Data fetched")
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        console.log("error",error)
        showError(error?.response?.data?.message || "Something went wrong. Please try again.");
      }
    } 
    // finally {
    //   setLoading(false);
    //   setLoadingDisRowId(null)
    // } 
  };

  return (
    <div style={profileStyle}>
<Toaster position="top-right" reverseOrder={false}/>
      {loading && <Loading />}
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            "& .MuiTabs-indicator": { backgroundColor: "rgb(124, 46, 160)" },
            "& .MuiTab-root": {
              color: "rgb(124, 46, 160)",
              textTransform: "none",
              fontWeight: 500,
            },
            "& .MuiTab-root.Mui-selected": {
              color: "rgb(124, 46, 160) !important",
              fontWeight: "bold",
            },
          }}
        >
          <Tab label="Amendment" />
          <Tab label="SOF" />
          <Tab label="Invoice" />
          <Tab label="Credit Note" />
          <Tab label="Other" />
        </Tabs>

        <Box sx={{ padding: 2 }}>
          {value === 0 && (
            <ViewTable
              value={value}
              columns={columns}
              rows={amendment}
              setModalIsOpen={setModalIsOpen}
              currentParam={currentParam}
            />
          )}
          {value === 1 && (
            <ViewTable
              value={value}
              columns={columns}
              rows={sof}
              setModalIsOpen={setModalIsOpen}
              currentParam={currentParam}
            />
          )}
          {value === 2 && (
            <>
            {currentParam && <InvoiceSummaryTable currentParam={currentParam}/>}
            <ViewTable
              value={value}
              columns={columns}
              rows={invoice}
              setModalIsOpen={setModalIsOpen}
              currentParam={currentParam}
              yearParam={yearParam}
              monthParam={monthParam}
              setSearchParam={setSearchParam}
              invoiceFiltersActive={invoiceFiltersActive}
              setYearParam={setYearParam}
              setMonthParam={setMonthParam}
              fetchInvoice={fetchInvoice}
            />
            {currentParam && <InvoiceSummaryTableB currentParam={currentParam}/>}
            </>
          )}
          {value === 3 && (
            <ViewTable
              value={value}
              columns={columns}
              rows={creditNote}
              setModalIsOpen={setModalIsOpen}
              currentParam={currentParam}
            />
          )}

          {value === 4 && (
            <ViewTable
              value={value}
              columns={columns}
              rows={other}
              setModalIsOpen={setModalIsOpen}
              currentParam={currentParam}
            />
          )}
        </Box>
        <UploadModal
          open={modalIsOpen}
          setOpen={setModalIsOpen}
          handleFileChange={handleFileChange}
          handleSubmit={handleSubmit}
          date={date}
          setDate={setDate}
          docId={docId}
          setDocId={setDocId}
          value={value}
        />
        <Discrepancy
          open={discrepancyModal}
          setOpen={setDiscrepancyModal}
          discrepancyData={discrepancyData}
          circuitTotals={discrepancyCircuitTotals}
          groupedServices={discrepancyGroupedServices}
          invoiceNo={invoiceNo}
          selectedColumn={selectedColumn}
        />
        <SofDetail
          open={detailModal}
          setOpen={setDetailModal}
          data={sofData}
          invoiceNo={invoiceNo}
        />
        <AmendmentDetail
          open={amendmentModal}
          setOpen={setAmendmentModal}
          data={sofData}
          invoiceNo={invoiceNo}
        />
        <MoreDetailsModal
          open={moreModalOpen}
          handleClose={() => setMoreModalOpen(false)}
          invoiceDetails={invoiceDetails}
        />
        <CreditNoteDetail
          open={creditNoteModal}
          setOpen={setCreditNoteModal}
          data={creditNoteData}
          invoiceNo={invoiceNo}
          invoice={invoice}
        />
         <CreditNoteDetailsModal
        open={openCreditModal}
        handleClose={() => setOpenCreditModal(false)}
        creditNotes={creditNoteData}
      />
        <Modal
          open={pdfViewerOpen}
          onClose={handlePdfViewerClose}
          style={{ zIndex: "99999" }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              height: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 1,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {loadingPdf ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexGrow: 1,
                  height: "100%",
                }}
              >
                <CircularProgress size={50} color="primary" />
              </Box>
            ) : (
              <iframe
                src={pdfUrl}
                // src={`https://docs.google.com/gview?url=${encodeURIComponent(
                //   pdfUrl
                // )}&embedded=true`}
                width="100%"
                height="100%"
                title="PDF Viewer"
                style={{ border: "none", flexGrow: 1 }}
                onLoad={handlePdfLoad}
              />
            )}
            <div style={{ display: "flex", alignSelf: "center", gap: "10px" }}>
              {/* <Button
                variant="contained"
                color="success"
                onClick={handleDownload}
                sx={{
                  mt: 2,
                  alignSelf: "center",
                  width: "150px",
                }}
              >
                Download
              </Button> */}
              <Button
                variant="contained"
                color="error"
                onClick={handlePdfViewerClose}
                sx={{
                  mt: 2,
                  alignSelf: "center",
                  width: "150px",
                }}
              >
                Close
              </Button>
            </div>
          </Box>
        </Modal>
      </Box>
    </div>
  );
}
const profileStyle = {
  // width: "94%",
  background: "#fff",
  borderRadius: "8px",
  marginInline: "16px",
  marginTop: "20px",
  padding: "20px",
};
  const { is_view } = getPermissionByPrefix("discrepancy");
  const { is_add:canAddInvoice } = getPermissionByPrefix("process_invoice");
  const { is_add:canAddSof } = getPermissionByPrefix("process_sof");
  const { is_add:canAddAmendment } = getPermissionByPrefix("process_amendment");
  const { is_add:canAddCredit } = getPermissionByPrefix("process_credit_note");

  const renderMonetaryCell = (isUsd, noPrefix = false) => (params) => {
    if (params.value === null || params.value === undefined || params.value === '') return "";
    
    let displayVal = String(params.value);
    if (!isNaN(Number(params.value))) {
      displayVal = Number(params.value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    if (noPrefix) {
      return displayVal;
    }
    
    if (isUsd) {
      return displayVal.startsWith("USD") ? displayVal : `USD ${displayVal}`;
    }
    
    if (params.row.currency && !displayVal.startsWith(params.row.currency)) {
      return `${params.row.currency} ${displayVal}`;
    }
    return displayVal;
  };

  const invoiceColumns = (getDiscrepancyrow, getFile, processFile, fetchCreditfromInvoice, viewType = 'individual') => [
  { field: "invoice_id", headerName: "Invoice Number", width: 135, description: "Unique invoice number extracted from the PDF" },
  { field: "account_no", headerName: "Account Number", width: 135, description: "Account number associated with this invoice in the PDF" },
  { field: "customer_id", headerName: "Customer ID", width: 135, description: "Customer ID found in the PDF" },
  { field: "format", headerName: "Format", width: 135, description: "Format of the invoice" },
  {
  field: "missing_services_status",
  headerName: "Services Status",
  width: 150,
  description: "Indicates if any services from the Statement of Fees are missing in this invoice",
  renderCell: (params) => (
    <span
      style={{
        color: params.value === "Incomplete" ? "red" : "green",
        fontWeight: 600,
      }}
    >
      {params.value}
    </span>
  ),
},
 
  // {
  //   field: "invoice_date",
  //   headerName: "Invoice Date",
  //   width: 135,
  //   type: "date",
  // },
  {
  field: "invoice_date",
  headerName: "Invoice Date",
  width: 135,
  type: "date",
  description: "Billing date extracted from the invoice PDF",
  renderCell: (params) => {
    if (!params.value) return "";
 
    const date = new Date(params.value);
    const [year, month, day] = date.toISOString().slice(0, 10).split("-");
 
    return `${day}-${month}-${year}`;
  },
},
  { field: "currency", headerName: "Currency", width: 100, description: "Currency of the invoice" },
  { field: "conversion_rate", headerName: "Conv. Rate", width: 110, description: "Currency conversion rate to USD", renderCell: (params) => {
    const val = params.value;
    if (val == null) return "—";
    return (
      <Tooltip title={String(val)} arrow placement="top">
        <span style={{ cursor: 'help' }}>{Number(val).toFixed(3)}</span>
      </Tooltip>
    );
  }},
  { field: "sum_amount", headerName: "Sum Amount", width: 135, description: "Sum of all raw line item amounts before taxes or discounts", renderCell: renderMonetaryCell(false) },
  { field: "sum_amount_usd", headerName: "Sum Amount USD", width: 175, description: "Sum of all raw line item amounts converted to USD", renderCell: renderMonetaryCell(true) },
  { field: "discount_and_promotion", headerName: "Discount & Promotion", width: 165, description: "Total discounts and promotions applied across all line items", renderCell: renderMonetaryCell(false) },
  { field: "discount_usd", headerName: "Discount USD", width: 155, description: "Total discounts and promotions in USD", renderCell: renderMonetaryCell(true, true) },
  { field: "taxes_and_surcharges", headerName: "Taxes", width: 135, description: "Total taxes and surcharges applied across all line items", renderCell: renderMonetaryCell(false) },
  { field: "taxes_usd", headerName: "Taxes USD", width: 135, description: "Total taxes and surcharges in USD", renderCell: renderMonetaryCell(true, true) },
  { field: "total_amount", headerName: "Total Amount", width: 135, description: "Total final amount for all line items in native currency", renderCell: renderMonetaryCell(false) },
  { field: "total_usd", headerName: "Total USD", width: 135, description: "Total final amount for all line items converted to USD", renderCell: renderMonetaryCell(true) },
  { field: viewType === 'grouped' ? "grouped_discrepancy_amount" : "total_discrepancy", headerName: "Total Discrepancy", width: 150, description: "Calculated difference between invoice amount and contracted Statement of Fees amount", renderCell: renderMonetaryCell(true) },
  {
    field: "total_adj",
    headerName: "Total Adjustment",
    width: 150,
    description: "Total adjustments or credit notes applied to resolve discrepancies",
    renderCell: (params) => {
      let displayVal = "";
      if (params.value !== null && params.value !== undefined && params.value !== '') {
        let valStr = String(params.value);
        if (!isNaN(Number(valStr))) {
          valStr = Number(valStr).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        displayVal = valStr.startsWith("USD") ? valStr : `USD ${valStr}`;
      }
      return (
        <span
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={()=> fetchCreditfromInvoice(params.row.invoice_id)}
        // onClick={() => console.log("Invoice ID:", params.row.invoice_id)}
        >
          {displayVal}
        </span>
      );
    },
  },
  { field: viewType === 'grouped' ? "grouped_discrepancy_final_amount" : "final_discrepancy", headerName: "Final Discrepancy", width: 150, description: "Remaining discrepancy after subtracting adjustments", renderCell: renderMonetaryCell(true) },
  {
    field: "discrepancy_detected",
    headerName: "Discrepancy Found",
    width: 150,
    description: "Indicates whether any discrepancies were found",
  },
  { field: "vendor_name", headerName: "Vendor Name", width: 135, description: "Name of the vendor issuing the invoice" },
  { field: "line_item_count", headerName: "Line Items", width: 100, description: "Total number of individual line items extracted from the PDF" },
  { field: "unique_service_count", headerName: "Unique Services", width: 135, description: "Count of unique service IDs found in the PDF" },
  { field: "unique_circuit_count", headerName: "Unique Circuits", width: 135, description: "Count of unique circuit IDs found in the PDF" },
  { field: "status", headerName: "Status", width: 135, description: "Processing status of the invoice" },
  {
    field: "actions",
    headerName: "Actions",
    width: 400,
    renderCell: (params) => (
      <>
        {params.row.status?.toLowerCase() === "processed" ? (<>{is_view && (
          <Button sx={{fontSize:"12px"}}
            variant="contained"
            onClick={() => getDiscrepancyrow(params.row)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <MdDifference color="#FFF" size={16} />
              Details
            </div>
          </Button>)}</>
        ) : (<>{canAddInvoice && (
          <Button
            variant="contained"
            onClick={() => processFile(0, params.row)}
            sx={{
              fontSize:"12px",
              backgroundColor: "rgb(34, 150, 34)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <CgSandClock color="#FFF" size={16} />
              Process
            </div>
          </Button>)}</>
        )}
        <Button
          variant="contained"
          onClick={() => getFile(params.row)}
          sx={{
            marginLeft: "5px",
            fontSize:"12px",
            backgroundColor: "rgb(124, 46, 160)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaEye color="#FFF" size={16} />
            View Invoice
          </div>
        </Button>
      </>
    ),
  },
];


const otherColumns = (getFile) => [
  { field: "name", headerName: "Name", width: 350 },
  {
    field: "actions",
    headerName: "Actions",
    width: 350,
    renderCell: (params) => (
      <>
        <Button
          variant="contained"
          onClick={() => getFile(params.row)}
          sx={{
            marginLeft: "5px",
            backgroundColor: "rgb(124, 46, 160)",
            fontSize:"12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaEye color="#FFF" size={18} />
            View Document
          </div>
        </Button>
      </>
    ),
  },
];

const sofColumns = (getDetail, getFile, processFile, fetchInvoiceDetails) => [
  { field: "name", headerName: "Name", width: 135 },
  // { field: "date", headerName: "Date", width: 150, type: "date" },
  // { field: "date", headerName: "Date", width: 150},
    {
  field: "date",
  headerName: "Date",
  width: 135,
  type: "date",
  renderCell: (params) => {
    if (!params.value) return "";

    const date = new Date(params.value);
    const [year, month, day] = date.toISOString().slice(0, 10).split("-");

    return `${day}-${month}-${year}`;
  },
},
  { field: "partial_match", headerName: "Partially Signed", width: 135 },
  {
  field: "ref_id",
  headerName: "Reference Id",
  width: 150,
  renderCell: (params) => (
    <span>
      {params?.value && params?.value?.trim() !== "" ? params?.value : "N/A"}
    </span>
  ),
},
  // { field: "ref_id", headerName: "Reference Id", width: 150 },
  // { field: "doc_id", headerName: "Document Id", width: 150 },
  {
    field: "doc_id",
    headerName: "Document ID",
    width: 150,
    renderCell: (params) => (
      <Tooltip title="View invoice detail">
        <span
          onClick={() => fetchInvoiceDetails(params.value)}
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {params.value}
        </span>
      </Tooltip>
    ),
  },
  { field: "currency", headerName: "Currency", width: 100 },
  { field: "sum_nrc", headerName: "Total NRC Amount", width: 150, renderCell: renderMonetaryCell(false) },
  { field: "sum_nrc_usd", headerName: "Total NRC USD", width: 150, renderCell: renderMonetaryCell(true) },
  { field: "sum_mrc", headerName: "Total MRC Amount", width: 150, renderCell: renderMonetaryCell(false) },
  { field: "sum_mrc_usd", headerName: "Total MRC USD", width: 150, renderCell: renderMonetaryCell(true) },
  { field: "status", headerName: "Status", width: 150 },
  {
    field: "actions",
    headerName: "Actions",
    width: 350,
    renderCell: (params) => (
      <>
        {params.row.status === "Processed" ? (
          <Button variant="contained" sx={{fontSize:"12px"}} onClick={() => getDetail(params.row, 1)}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <BiMessageSquareDetail color="#FFF" size={16} />
              Detail
            </div>
          </Button>
        ) : (<>{canAddSof && (
          <Button
            variant="contained"
            onClick={() => processFile(1, params.row)}
            sx={{
              backgroundColor: "rgb(34, 150, 34)",
              fontSize:"12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <CgSandClock color="#FFF" size={16} />
              Process
            </div>
          </Button>)}</>
        )}
        <Button
          variant="contained"
          onClick={() => getFile(params.row)}
          sx={{
            marginLeft: "5px",
            backgroundColor: "rgb(124, 46, 160)",
            fontSize:"12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaEye color="#FFF" size={16} />
            View SOF
          </div>
        </Button>
      </>
    ),
  },
];

const creditColumns = (
  getDetail,
  getFile,
  processFile,
  fetchInvoiceDetails
) => [
  { field: "name", headerName: "Name", width: 135, description: "Filename of the credit note PDF" },
  // { field: "date", headerName: "Date", width: 150 },
    {
  field: "date",
  headerName: "Date",
  width: 135,
  type: "date",
  description: "Date of the credit note extracted from the PDF",
  renderCell: (params) => {
    if (!params.value) return "";
 
    const date = new Date(params.value);
    const [year, month, day] = date.toISOString().slice(0, 10).split("-");
 
    return `${day}-${month}-${year}`;
  },
},
  // { field: "doc_id", headerName: "Document Id", width: 150 },
  {
    field: "doc_id",
    headerName: "Document ID",
    width: 150,
    description: "Unique document identifier for this credit note",
    // renderCell: (params) => (
    //   <Tooltip title="View invoice detail">
    //     <span
    //       onClick={() => fetchInvoiceDetails(params.value)}
    //       style={{
    //         color: "blue",
    //         textDecoration: "underline",
    //         cursor: "pointer",
    //       }}
    //     >
    //       {params.value}
    //     </span>
    //   </Tooltip>
    // ),
  },
  { field: "currency", headerName: "Currency", width: 100, description: "Currency of the credit note" },
  { field: "sum_amount", headerName: "Sum Amount", width: 135, description: "Sum of all raw line item amounts before taxes or discounts", renderCell: renderMonetaryCell(false) },
  { field: "sum_amount_usd", headerName: "Sum Amount USD", width: 175, description: "Sum of all raw line item amounts converted to USD", renderCell: renderMonetaryCell(true) },
  { field: "discount_and_promotion", headerName: "Discount & Promotion", width: 165, description: "Total discounts and promotions applied across all line items", renderCell: renderMonetaryCell(false) },
  { field: "taxes_and_surcharges", headerName: "Taxes", width: 135, description: "Total taxes and surcharges applied across all line items", renderCell: renderMonetaryCell(false) },
  { field: "total_amount", headerName: "Total Amount", width: 135, description: "Total final amount for all line items in native currency", renderCell: renderMonetaryCell(false) },
  { field: "total_usd", headerName: "Total USD", width: 135, description: "Total final amount for all line items converted to USD", renderCell: renderMonetaryCell(true) },
  { field: "line_item_count", headerName: "Line Items", width: 100, description: "Total number of individual line items extracted from the PDF" },
  { field: "status", headerName: "Status", width: 150, description: "Processing status of the credit note" },
  {
    field: "actions",
    headerName: "Actions",
    width: 400,
    renderCell: (params) => (
      <>
        {params.row.status === "Processed" ? (
          <Button variant="contained" sx={{fontSize:"12px"}} onClick={() => getDetail(params.row, 4)}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <BiMessageSquareDetail color="#FFF" size={18} />
              Detail
            </div>
          </Button>
        ) : (<>{canAddCredit && (
          <Button
            variant="contained"
            onClick={() => processFile(4, params.row)}
            sx={{
              backgroundColor: "rgb(34, 150, 34)",
              fontSize:"12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <CgSandClock color="#FFF" size={18} />
              Process
            </div>
          </Button>)}</>
        )}
        <Button
          variant="contained"
          onClick={() => getFile(params.row)}
          sx={{
            marginLeft: "5px",
            backgroundColor: "rgb(124, 46, 160)",
            fontSize:"12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaEye color="#FFF" size={18} />
            View Credit Note
          </div>
        </Button>
      </>
    ),
  },
];
 

const ammendentColumns = (getDetail, getFile, processFile) => [
  { field: "name", headerName: "Name", width: 135 },
  // { field: "date", headerName: "Date", width: 150 },
    {
  field: "date",
  headerName: "Date",
  width: 135,
  type: "date",
  renderCell: (params) => {
    if (!params.value) return "";

    const date = new Date(params.value);
    const [year, month, day] = date.toISOString().slice(0, 10).split("-");

    return `${day}-${month}-${year}`;
  },
},
  { field: "doc_id", headerName: "Document Id", width: 150 },
  { field: "status", headerName: "Status", width: 150 },
  {
    field: "actions",
    headerName: "Actions",
    width: 350,
    renderCell: (params) => (
      <>
        {params.row.status === "Processed" ? (
          <Button variant="contained" onClick={() => getDetail(params.row, 2)} sx={{fontSize:"12px"}}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <BiMessageSquareDetail color="#FFF" size={16} />
              Detail
            </div>
          </Button>
        ) : (<>{canAddAmendment && (
          <Button
            variant="contained"
            onClick={() => processFile(2, params.row)}
            sx={{
              backgroundColor: "rgb(34, 150, 34)",
              fontSize:"12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <CgSandClock color="#FFF" size={16} />
              Process
            </div>
          </Button>)}</>
        )}
        <Button
          variant="contained"
          onClick={() => getFile(params.row)}
          sx={{
            marginLeft: "5px",
            fontSize:"12px",
            backgroundColor: "rgb(124, 46, 160)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaEye color="#FFF" size={16} />
            View Amendment
          </div>
        </Button>
      </>
    ),
  },
];

const ViewTable = ({ value, columns: columnsProp, rows, setModalIsOpen, currentParam, yearParam, monthParam, setSearchParam, invoiceFiltersActive, setYearParam, setMonthParam, fetchInvoice }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
    const { is_add } = getPermissionByPrefix("manage_document");
const tableRef = React.useRef();
const [invoiceViewType, setInvoiceViewType] = useState('grouped');

// Swap columns based on invoiceViewType for invoice tab
const columns = React.useMemo(() => {
  if (value !== 2) return columnsProp;
  return columnsProp.map(col => {
    if (col.headerName === 'Total Discrepancy') {
      return { 
        ...col, 
        field: invoiceViewType === 'grouped' ? 'grouped_discrepancy_amount' : 'total_discrepancy'
      };
    }
    if (col.headerName === 'Final Discrepancy') {
      return { 
        ...col, 
        field: invoiceViewType === 'grouped' ? 'grouped_discrepancy_final_amount' : 'final_discrepancy'
      };
    }
    return col;
  });
}, [columnsProp, invoiceViewType, value]);

const handleDownloadCSV = () => {
  if (!columns || !rows || rows.length === 0) return;

  // ✅ Get only filtered rows
  const filteredRows = tableRef.current?.getFilteredRows() || [];
  // console.log("Filtered rows: ", filteredRows);

  if (filteredRows.length === 0) {
    alert("No filtered data to export.");
    return;
  }

  const headers = columns
    .filter((col) => col.field !== "actions")
    .map((col) => col.headerName);

  const csvRows = [];
  csvRows.push(headers.join(",")); // Header row

  filteredRows.forEach((row) => {
    const rowData = columns
      .filter((col) => col.field !== "actions")
      .map((col) => {
        let value = row[col.field];
        if (value === null || value === undefined) value = "N/A";
        if (value instanceof Date) value = value.toLocaleDateString();
        return `"${String(value).replace(/"/g, '""')}"`;
      });

    csvRows.push(rowData.join(","));
  });

  const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  
  const docType = value === 0 ? "Amendment" : value === 1 ? "SOF" : value === 2 ? (invoiceViewType === 'grouped' ? "Grouped_Invoices" : "Individual_Invoices") : value === 3 ? "Credit_Note" : "Documents";
  const date = new Date();
  const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}-${String(date.getMinutes()).padStart(2, '0')}-${String(date.getSeconds()).padStart(2, '0')}`;
  
  link.setAttribute("download", `${docType}_${dateStr}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


//   const handleDownloadCSV = () => {
//   if (!columns || !rows || rows.length === 0) return;
//   const headers = columns
//     .filter((col) => col.field !== "actions")
//     .map((col) => col.headerName);
//   const csvRows = [];
//   csvRows.push(headers.join(","));
//   rows.forEach((row) => {
//     const rowData = columns
//       .filter((col) => col.field !== "actions")
//       .map((col) => {
//         let value = row[col.field];
//         if (value === null || value === undefined) value = "N/A";
//         if (value instanceof Date) {
//           value = value.toLocaleDateString();
//         }
//         return `"\t${String(value).replace(/"/g, '""')}"`;
//       });
//     csvRows.push(rowData.join(","));
//   });
//   const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
//   const encodedUri = encodeURI(csvContent);
//   const link = document.createElement("a");
//   link.setAttribute("href", encodedUri);
//   link.setAttribute("download", `Invoices_${new Date().toISOString()}.csv`);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

  return (
    <>
      <div className="table-header">
<h2>
  {value === 0
    ? "Amendment"
    : value === 1
    ? "SOF"
    : value === 2
    ? (() => {
        let label = "";
        if (currentParam === "remaining_discrepancy") label = "Remaining Discrepancy";
        else if (currentParam === "settled_discrepancy") label = "Settled Discrepancy";
        else if (currentParam === "discrepancy") label = "Discrepancy";
        return `Invoices${label ? ` (${label})` : ""}`;
      })()
    : value === 3
    ? "Credit Note"
    : "Documents"}
</h2>
        <div style={{ display: "flex", gap: "10px" }}>

          {value === 2 && (
               <Tooltip title="View Discrepancy Process">
        <span
          onClick={handleOpen}
          style={{
            cursor: "pointer",
            alignContent:"center",
            marginTop:"4px",
          }}
        >
          <IoIosInformationCircleOutline size={25}/>
        </span>
      </Tooltip>
          )}

          {[1, 2, 3].includes(value) && (
            <Tooltip title="Download CSV" placement="top" arrow>
              <span
                onClick={handleDownloadCSV}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  backgroundColor: "#f5f5f5",
                  transition: "all 0.2s ease",
                  margin: "10px",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e0e0e0")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
              >
                <PiFileCsv size={20} color="#333" />
              </span>
            </Tooltip>
          )}
          {is_add && (
          // <button
          //   className="upload-button"
          //   onClick={() => setModalIsOpen(true)}
          // >
          //   <img src="/upload.png" alt="Upload Icon" />
          //   Upload{" "}
          //   {value === 0
          //     ? "Amendment"
          //     : value === 1
          //     ? "SOF"
          //     : value === 2
          //     ? "Invoice"
          //     : value === 3
          //     ? "Credit Note"
          //     : "Document"}
          // </button>
<Tooltip
  title={
    value === 0
      ? "Upload Amendment"
      : value === 1
      ? "Upload SOF"
      : value === 2
      ? "Upload Invoice"
      : value === 3
      ? "Upload Credit Note"
      : "Upload Document"
  }
  placement="top"
  arrow
>
  <span
    onClick={() => setModalIsOpen(true)}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: "50%",
      margin:"auto",
      width: "36px",
      height: "36px",
      backgroundColor: "#f5f5f5",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e0e0e0")}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
  >
    <FiUpload size={20} color="#333" />
  </span>
</Tooltip>


        )}

 {/* {value === 2 && 
<YearMonthFilter
  year={yearParam}
  month={monthParam}
  onFilterChange={(year, month) => {
    setYearParam(year);
    setMonthParam(month);
    fetchInvoice(false, year, month);
  }}
/>}
                    {value === 2 && invoiceFiltersActive && (
  <Button
    variant="outlined"
    color="error"
    style={{ marginLeft: 1 }}
    onClick={() => {
      setSearchParam({ tab: "invoice" });
      setYearParam(null);
      setMonthParam(null);
       fetchInvoice(false, null, null);
    }}
  >
    Reset
  </Button>
)} */}
{value === 2 && (
  <div style={{alignContent:"center", display:"flex", alignItems: "center"}}>
    {/* Toggle Grouped / Individual */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#f1f5f9',
        borderRadius: '20px',
        padding: '2px',
        marginRight: '15px'
      }}
    >
      <Box
        onClick={() => setInvoiceViewType('grouped')}
        sx={{
          padding: '4px 12px',
          borderRadius: '18px',
          fontSize: '0.75rem',
          fontWeight: invoiceViewType === 'grouped' ? 600 : 400,
          color: invoiceViewType === 'grouped' ? '#fff' : '#64748b',
          backgroundColor: invoiceViewType === 'grouped' ? '#7C2EA0' : 'transparent',
          transition: 'all 0.2s ease-in-out',
          cursor: 'pointer',
        }}
      >
        Grouped
      </Box>
      <Box
        onClick={() => setInvoiceViewType('individual')}
        sx={{
          padding: '4px 12px',
          borderRadius: '18px',
          fontSize: '0.75rem',
          fontWeight: invoiceViewType === 'individual' ? 600 : 400,
          color: invoiceViewType === 'individual' ? '#fff' : '#64748b',
          backgroundColor: invoiceViewType === 'individual' ? '#7C2EA0' : 'transparent',
          transition: 'all 0.2s ease-in-out',
          cursor: 'pointer',
        }}
      >
        Individual
      </Box>
    </Box>
    {/* Date Range Filter */}
    <DateRangeFilter
      onFilterChange={(start, end) => {
        // disable year/month filter
        setYearParam(null);
        setMonthParam(null);
        fetchInvoice(true, null, null, start, end);
      }}
      onReset={() => {
        fetchInvoice(false, null, null, null, null);
      }}
    />
 {value === 2 && invoiceFiltersActive && (
  // <Button
  //   variant="outlined"
  //   color="error"
  //   style={{ height:"40px", margin:"auto" }}
  //   onClick={() => {
  //     setSearchParam({ tab: "invoice" });
  //     setYearParam(null);
  //     setMonthParam(null);
  //      fetchInvoice(false, null, null);
  //   }}
  // >
  //   Reset Table
  // </Button>
  <Tooltip title="This will reset filters and show all invoices.">
  <Button
    variant="outlined"
    color="error"
    style={{ height:"32px", margin:"auto", whiteSpace:"nowrap", fontSize:"10px" }}
    onClick={() => {
      setSearchParam({ tab: "invoice" });
      setYearParam(null);
      setMonthParam(null);
      fetchInvoice(false, null, null);
    }}
  >
    Back to Invoice table
  </Button>
</Tooltip>
)}
    {/* Existing Year-Month Filter (still usable separately) */}
    {/* <YearMonthFilter
      year={yearParam}
      month={monthParam}
      onFilterChange={(year, month) => {
        setYearParam(year);
        setMonthParam(month);
        fetchInvoice(false, year, month, null, null);
      }}
    /> */}
  </div>
)}

        </div>
      </div>
      <DataTable ref={tableRef} columns={columns} rows={rows} />
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        style={{ zIndex: "9999999" }}
      >
        <DialogTitle>Discrepancy Process</DialogTitle>
        <DialogContent
          style={{ display: "flex", justifyContent: "center", padding: "16px" }}
        >
          <img
            src="./process.png"
            alt="Discrepancy Process"
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
          />
        </DialogContent>
        <div style={{ display: "flex", alignSelf: "center" }}>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{
              mt: 2,
              alignSelf: "center",
              width: "150px",
              marginBottom: "20px",
            }}
          >
            Close
          </Button>
        </div>
      </Dialog>
    </>
  );
};

export default Document;
